import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAsObservableSource } from 'mobx-react-lite';
import { SwitcherLabelWrapper, Label, Input, Slider, SwitcherWrapper, Wrapper } from './SwitcherWithLabel.style';

export interface PropsType {
    label: string,
    isSwitched: boolean,
    disabled?: boolean,
    onChangeAction: () => Promise<void>
}

export const SwitcherWithLabel = observer('SwitcherWithLabel', (propsIn: PropsType) => {
    const props = useAsObservableSource(propsIn);
    const { isSwitched, disabled, label, onChangeAction } = props;

    const handleChange = async (): Promise<void> => {
        await onChangeAction();
    };

    return (
        <SwitcherLabelWrapper>
            <Wrapper disabled={disabled}>
                <SwitcherWrapper>
                    <Input
                        type='checkbox'
                        checked={isSwitched}
                        readOnly
                        onChange={handleChange}
                    />
                    <Slider />
                </SwitcherWrapper>
            </Wrapper>
            <Label>{ label }</Label>
        </SwitcherLabelWrapper>
    );
});
